import { createContext } from "react";

import type { User, UserRole } from "@/api/types";

export interface AuthState {
  user: User | null;
  status: "loading" | "authenticated" | "anonymous";
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  /** Client-side convenience only. The server enforces permissions regardless. */
  can: (...roles: UserRole[]) => boolean;
}

export const AuthContext = createContext<AuthState | null>(null);
